(ns ycweb.app.website.products.product
  (:require
   #?@(:clj
       [[clj-time.core :as dt]
        [clj-time.coerce :as dtc]]
       :cljs
       [[cljs-time.core :as dt]
        [cljs-time.coerce :as dtc]])
   [rum.core :as rum]
   [ycweb.app.website.website :as website]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.flow :as flow]
   [ycweb.components.grid :as grid]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.components.scroll :as scroll]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as yuc]
   [ycweb.util.urlstate :as urlstate]
   [ycweb.app.website.common :as web-common]
   [util.string :as str]
   [util.transform :as trf]
   [ycweb.app.website.products.components.gallery :as gallery]
   [ycweb.app.website.products.components.icons :as icons]
   [ycweb.app.website.products.components.content-panels :as panels]
   [ycweb.app.website.cards :as cards]
   [ycweb.app.website.products.components.variation-list :as vlist]
   [ycweb.app.website.myaccount.reviews.common :as reviews-common]
   [ycweb.app.website.products.components.notify-me :as notify-me]
   [ycweb.app.website.products.components.hunt :as hunt]
   [ycweb.app.website.cart.model :as cart-model]
   [ycweb.app.website.cart.addtocart]
   [ycweb.app.website.tracking :as tracking]))

(defonce ^:private last-impression-atom (atom nil))

(defn- add-to-wishlist [app-atom variation-id]
  (let [user (cmn/curact app-atom [:user])
        logged-in? (some? user)]
    (if logged-in?
      (do
        (toaster/open-overlay app-atom :web.product/loading)
        (comms/ajax-post :web.product/add-to-wishlist {:variation-id variation-id}))
      #?(:cljs
         (set! js/window.location
           (str "/login.htm?afterloginredirect=" (.-pathname js/window.location)
             (.-search js/window.location)))
         :clj nil))))

(defmethod comms/receive :web.product/add-to-wishlist [app-atom e]
  (toaster/close-overlay app-atom :web.product/loading)
  ;; Only present on genuinely-new adds — repeat adds must not re-fire
  (when-let [dl (:datalayer e)]
    ;; Through the clear, so no earlier event's eventID lingers
    (tracking/push-ecommerce-event! dl))
  (grid/message-modal app-atom
    {:title "Wish list"
     :text (or (:message e) "Added to your wish list.")
     :type (if (= :already (:status e)) :warning :success)
     :confirm-text "OK"}))

(rum/defc check-discount-modal-body < rum/reactive [app-atom]
  (let [config (:config (rum/react (grid/modal-cursor app-atom)))]
    [:div.modal__body
     [:h3.modal__heading
      {:class (yuc/bem :heading [:medium-large])
       :style {:text-align "center" :margin-right 0}}
      (:title config)]
     (:text config)]))

(defmethod grid/modal-config :web.product/check-discount [_ _ _]
  {:body check-discount-modal-body
   :footer grid/modal-message-footer
   :modal-type :alert
   :requires-action true
   :max-width "380"})

(defmethod comms/receive :web.product/check-discount [app-atom e]
  (if (:success e)
    (grid/open-modal app-atom :web.product/check-discount
      {:title "Staff Discount"
       :text
       [:div.u-text-center
        {:style {:padding "8px 0"}}
        [:div {:style {:color "#888" :font-size "13px" :margin-bottom "2px"}}
         "Original price"]
        [:div
         {:style {:color "#888" :font-size "20px" :text-decoration "line-through"
                  :margin-bottom "16px"}}
         (str "R" (yuc/number-format (:original-price e) 0))]
        [:div {:style {:font-size "13px" :margin-bottom "2px"}}
         "Staff price"]
        [:div
         {:style {:font-size "28px" :font-weight "700" :margin-bottom "20px"}}
         (str "R" (yuc/number-format (:discounted-price e) 0))]
        [:div
         {:style {:background "#f0faf0" :border-radius "6px"
                  :padding "10px 16px" :display "inline-block"}}
         [:span.text-status.text-status--success
          {:style {:font-size "15px" :font-weight "600"}}
          (str "You save R" (yuc/number-format (:savings e) 0))]]]
       :confirm-text "OK"})
    (grid/message-modal app-atom
      {:title "Staff Discount"
       :text (or (:message e) "Could not calculate discount.")
       :type :warning
       :confirm-text "OK"})))

(defn- do-add-to-cart [app-atom variation-uuid qty]
  (swap! (cmn/process-cursor app-atom) assoc :adding-to-cart true)
  (cart-model/add-to-cart app-atom
    {:variation_uuid variation-uuid
     :qty qty
     :addsource "productdetail"}
    (fn [response]
      (swap! (cmn/process-cursor app-atom) dissoc :adding-to-cart)
      (when (:success response)
        (cart-model/open-add-to-cart-modal app-atom response
          :variation-uuid variation-uuid)))))

(defmethod grid/action :web.product/add-to-cart [app-atom config _]
  (let [{:keys [variation-uuid qty geofenced-snippet]} config]
    (if (yuc/presence geofenced-snippet)
      (grid/message-modal app-atom
        {:title "Only delivered to selected areas"
         :text [:div
                [:p [:b.text-status.text-status--error "Have you checked the delivery schedule?"]
                 " This item can only be delivered to selected areas."]
                [:div {:dangerouslySetInnerHTML {:__html geofenced-snippet}}]]
         :type :warning
         :confirm-text "Add to Cart anyway"
         :confirm-fn
         (fn [& _]
           (do-add-to-cart app-atom variation-uuid qty))
         :cancel-text "Cancel"})
      (do-add-to-cart app-atom variation-uuid qty))))

(defn- add-to-registry [app-atom variation-id]
  (let [user (cmn/curact app-atom [:user])
        logged-in? (some? user)]
    (if logged-in?
      (do
        (swap! (cmn/process-cursor app-atom) assoc :registry-action :add-product-item
          :pending-registry-variation-id variation-id)
        (toaster/open-overlay app-atom :web.product/loading)
        (grid/dispatch-action app-atom :web.registry/edit.choose {}))
      #?(:cljs
         (set! js/window.location
           (str "/login.htm?afterloginredirect=" (.-pathname js/window.location)
             (.-search js/window.location)))
         :clj nil))))

(defn- url-query-param [k]
  #?(:cljs
     (when-let [params (js/URLSearchParams. js/window.location.search)]
       (.get params k))
     :clj nil))

;; Read URL params after :did-mount so SSR + first hydration see the same
;; (empty) shape; the input appears once the client has reconciled with the DOM.
;; Avoids the "Expected server HTML to contain a matching <input>" warning.
(rum/defcs eventid-hidden-input
  < (rum/local nil ::eventid)
  {:did-mount
   (fn [state]
     (reset! (::eventid state) (yuc/presence (url-query-param "eventid")))
     state)}
  [state]
  (when-let [eid @(::eventid state)]
    [:input {:type "hidden" :name "eventid" :value eid}]))

(defn help-link [app-atom article-id link-text]
  [:a.text-link
   {:href (str "/help.htm?action=article&id=" article-id)
    :on-click
    (fn [e]
      (.preventDefault e)
      (panels/open-help-article app-atom article-id))}
   link-text])

(defn- special-image-url [special]
  (when
    (and
      (:special/show_special_image special)
      (:special/gift-thumbnail-id special))
    (str "https://res.cloudinary.com/yuppiechef/image/upload/"
      "c_limit,w_240,h_240/"
      (:special/gift-thumbnail-id special) ".jpg")))

(defn- open-special-modal [app-atom special]
  (grid/message-modal app-atom
    {:title
     [:span.u-text-red.promo-popup-title
      {:dangerouslySetInnerHTML {:__html (:special/comments special)}}]
     :text
     [:div
      (when-let [img-src (special-image-url special)]
        [:div.u-block-center.u-max-width-240.u-margin-bottom-24
         [:img.yc-simple-image.yc-simple-image--full
          {:src img-src :alt "" :width "240" :height "240"}]])
      [:div {:dangerouslySetInnerHTML {:__html (:special/long-desc special)}}]]
     :confirm-text "Close"}))

(defn- php-epoch->datetime [epoch-seconds]
  (when (and epoch-seconds (pos? epoch-seconds))
    (dtc/from-long (* 1000 (+ (* 2 60 60) epoch-seconds)))))

(defn- calc-time-diff [end-date]
  (let [start-date (dt/plus (dt/now) (dt/hours 2))
        done? (dt/after? start-date end-date)
        interval-date (when-not done? (dt/interval start-date end-date))
        difference-ms (when interval-date (dt/in-millis interval-date))
        seconds (/ difference-ms 1000)
        minutes (/ seconds 60)
        hours (/ minutes 60)
        days (/ hours 24)]
    {:done? done?
     :days (str/format "%02d" (Math/floor days))
     :hours (str/format "%02d" (Math/floor (mod hours 24)))
     :minutes (str/format "%02d" (Math/floor (mod minutes 60)))
     :seconds (str/format "%02d" (Math/floor (mod seconds 60)))}))

(rum/defcs product-countdown-timer <
  (rum/local nil ::countdown)
  (rum/local nil ::interval-id)
  {:did-mount
   (fn [state]
     #?(:cljs
        (let [[special] (:rum/args state)
              end-date (php-epoch->datetime (:special/dateto special))
              countdown-atom (::countdown state)
              interval-atom (::interval-id state)]
          (when end-date
            (reset! countdown-atom (calc-time-diff end-date))
            (reset! interval-atom
              (.setInterval js/window
                (fn []
                  (let [t (calc-time-diff end-date)]
                    (reset! countdown-atom t)
                    (when (:done? t)
                      (.clearInterval js/window @interval-atom))))
                1000)))))
     state)
   :will-unmount
   (fn [state]
     #?(:cljs
        (when-let [id @(::interval-id state)]
          (.clearInterval js/window id)))
     state)}
  [state special]
  (let [{:keys [done? days hours minutes seconds]} @(::countdown state)]
    (when (some? days)
      [:div.product-page-countdown
       [:p.yc-paragraph.yc-paragraph--flush.text-status.text-status--sale.u-text-uppercase
        [:b "Limited time offer"]]
       [:div {:class (str "countdown countdown--small" (when done? " countdown--finish"))}
        [:span.countdown__item {:data-ttt "Days"} days]
        [:span.countdown__divider ":"]
        [:span.countdown__item {:data-ttt "Hrs"} hours]
        [:span.countdown__divider ":"]
        [:span.countdown__item {:data-ttt "Min"} minutes]
        [:span.countdown__divider ":"]
        [:span.countdown__item {:data-ttt "Sec"} seconds]]])))

(defn- generate-url [name-str]
  (let [clean-name (str/replace name-str "Pages" "Index")]
    (str "/" (str/lower-case (str/replace clean-name " " "-")) ".htm")))

(defn- get-display-name [item]
  (let [real-name (get-in item [:category/lookfeel :realname])]
    (cond
      (yuc/presence real-name)
      real-name

      :else
      (str/replace (:category/name item) "Pages" "Home"))))

(defn- build-feature-string [feature1 feature3]
  (->> [feature1 feature3]
    (remove str/blank?)
    (str/join " ")))

(rum/defc breadcrumbs < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        {:keys [category category-paths]} (cmn/curact process-atom :categories)]
    (when (seq category-paths)
      [:ul.breadcrumbs.group
       (for [item category-paths]
         (when (not (contains? #{9 134} (:category/id item)))
           (let [id (:category/id item)
                 parent-id (:category/refers-to item)
                 is-shop-all-parent? (= parent-id 157)
                 is-current? (= id (:category/id category))
                 base-class "breadcrumbs__item"
                 final-class
                 (cond-> base-class
                   is-current? (str " last-child")
                   is-shop-all-parent? (str " breadcrumbs__item--always-show"))]

             [:li
              {:key id
               :class final-class}
              [:a.breadcrumb__link
               {:href (generate-url (:category/name item))}

               (when is-shop-all-parent?
                 [:span.unclip-text--s.clip-text--m
                  [:i.icon.icon--arrow-left.icon--is-dark.icon--small.icon--inline]
                  "Shop all "])

               (get-display-name item)]])))])))

(defn get-product-name-ex-brand [product]
  (str/trim (str/replace (:name product) (:product/brand-root-name product) "")))

(rum/defc product-header < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        product (cmn/curact process-atom :product)
        {:variation/keys [feature1 feature2 feature3]}
        (cmn/curact process-atom :variation)

        content-name (get-product-name-ex-brand product)
        heading-var-feature (build-feature-string feature1 feature3)

        has-f1? (not (str/blank? feature1))
        has-f2? (not (str/blank? feature2))
        has-f3? (not (str/blank? feature3))]

    [:h1.product-page-title
     [:a.text-link.text-link--unmarked
      {:href (generate-url (:product/brand-root-name product))}
      (:product/brand-root-name product)]
     (str " " content-name)
     [:span.u-hidden-from-view "—"]
     [:span.product-page-title__variation
      (when (or has-f1? has-f2? has-f3?)
        (cond
          has-f2?
          [:span.product-page-title__variation (str "Colour: " feature2)]

          (or has-f1? has-f3?)
          [:span.product-page-title__variation (str "Variant: " heading-var-feature)]))]]))

(rum/defc product-packsize < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        {:variation/keys [pack-description display_packsize]}
        (cmn/curact process-atom :variation)]
    (when (and (not (str/blank? (str pack-description)))
            (not (str/blank? (str display_packsize)))
            (> (or display_packsize 0) 1))
      [:div.product-page-packsize
       [:span.product-page-packsize__pill.text-pill.text-pill--dark.u-text-uppercase
        (str pack-description " of " display_packsize)]])))

(rum/defc reviews-meta < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        {:keys [review-stats]} (cmn/curact process-atom :product)
        variation (cmn/curact process-atom :variation)
        {:review-stats/keys [total-reviews avg-stars]} review-stats]
    [:ul.reviews-meta
     (when (> total-reviews 0)
       [:li.reviews-meta__item
        [:a.star-rating.star-rating--large.js-smoothscroll
         (merge
           (urlstate/href-on-click #(scroll/scroll-to-id % (str/replace "#reviews" #"\#" "")))
           {:href "#reviews"
            :class (str "star-rating--" (* 5 (int (+ 0.5 (/ (* avg-stars 10) 5.0)))))})
         [:span.u-hidden-from-view
          (str "This product has an average rating of " (yuc/number-format avg-stars 1) " out of 5 stars")]]])
     (when (> total-reviews 0)
       [:li.reviews-meta__item
        [:a.text-link.js-smoothscroll
         (merge
           (urlstate/href-on-click #(scroll/scroll-to-id % (str/replace "#reviews" #"\#" "")))
           {:href "#reviews"})
         (str "From " total-reviews)
         [:span.clip-text.unclip-text--s
          (str " review" (if (> total-reviews 1) "s" ""))]]])
     [:li.reviews-meta__item
      [:a.text-link.write_review
       (urlstate/href-props app-atom "myaccount" "reviewsadd"
         {:uuid (:variation/uuid variation)})
       "Write a review"]]]))

(rum/defc page-header < rum/reactive [app-atom & [attrs]]
  (let [process-atom (cmn/process-cursor app-atom)
        {:product/keys [reviewable] :keys [specials]} (cmn/curact process-atom :product)
        time-special
        (->>
          specials
          (filter #(= 1 (:special/timebased %)))
          (first))]
    [:div.flex-grid-content (or attrs {})
     (breadcrumbs app-atom)
     (when time-special
       [:p.product-page-pretitle.yc-paragraph.text-status.text-status--sale.u-text-uppercase
        [:b "Limited time offer"]])
     (product-header app-atom)
     (product-packsize app-atom)
     (when reviewable
       (reviews-meta app-atom))]))

(rum/defc geofence-modals < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        product (cmn/curact process-atom :product)
        variation (cmn/curact process-atom :variation)
        geofenced-snippet
        (or
          (:variation/geofenced-snippet variation)
          (:geofenced_snippet product))]
    (when (yuc/presence geofenced-snippet)
      [:div.geofence-popups
       [:div.yc-popup.mfp-hide.js-geofence-shipping-info
        [:div.yc-popup__content
         [:h2 "This item can only be delivered to selected areas."]
         [:div {:dangerouslySetInnerHTML {:__html geofenced-snippet}}]]]
       [:div.modal--is-warning.mfp-hide.js-warn-geo-popup
        [:div.modal__header
         [:h2 "Only delivered to selected areas"]]
        [:div.modal__content
         [:p [:b.text-status.text-status--error "Have you checked the delivery schedule?"]
          " This item can only be delivered to selected areas."]
         [:div {:dangerouslySetInnerHTML {:__html geofenced-snippet}}]]
        [:form.modal__footer.form
         [:button.button.button--default.button--secondary.js-warn-geofence-cancel
          {:type "button"}
          [:span.button__text "No, cancel"]]
         [:button.button.button--default.button--primary.js-warn-geofence-continue
          {:type "submit"}
          [:span.button__text "Yes, add to Cart"]]]]])))

(rum/defc variation-teaser < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        product (cmn/curact process-atom :product)
        teaser (:teaser product)]
    (when (yuc/presence teaser)
      (let [clean-text (str/strip-tags teaser)
            truncated? (> (count clean-text) 140)
            display-text
            (if truncated?
              (str (subs clean-text 0 140) "\u2026")
              clean-text)]
        [:div.product-teaser {:aria-hidden "true"}
         [:h2.yc-heading.yc-heading--default "Product details"]
         [:p.yc-paragraph {:aria-hidden "true"}
          display-text
          (when truncated?
            [:a.text-link
             {:href "#"
              :on-click
              (fn [e]
                (.preventDefault e)
                (panels/open-panel process-atom :info))}
             " Read more."])]]))))

(defn not-sellable?
  "Server-computed in ->variation — the raw stock integers never reach the client."
  [variation]
  (boolean (:variation/not-sellable? variation)))

(def ^:private help-article-delivery-charges 181)
(def ^:private help-article-delivery-times 38)

;; Same maths as Payflex's calculator widget (widgets.payflex.co.za 2.0.3).
;; https://docs.payflex.co.za/docs/widgets
(defn- payflex-instalment
  "Formats a Pay-in-4 instalment for amount, e.g. R1,999.75 or R2,000."
  [amount]
  (let [instalment (/ (Math/floor (/ (* amount 100) 4.0)) 100)]
    (str "R" (yuc/number-format instalment (if (== instalment (Math/floor instalment)) 0 2)))))

(rum/defc variation-price-block < rum/static [app-atom product variation]
  (let [process-atom (cmn/process-cursor app-atom)
        {:variation/keys [price price-was selling-pack-size]} variation
        {:keys [specials]} product
        delivery-threshold (or (cmn/curact process-atom :delivery-threshold) 0)
        has-pack-size? (and selling-pack-size (> selling-pack-size 1))
        has-was-price? (and price-was (> price-was price))
        display-price (if has-pack-size? (* price selling-pack-size) price)
        display-pricewas
        (when has-was-price?
          (if has-pack-size? (* price-was selling-pack-size) price-was))
        alt-price (* (or price 0) 10)
        admin-specials? (cmn/curact process-atom :admin-specials?)
        specials-to-show
        (filter
          (fn [s]
            (and
              (yuc/presence (:special/long-desc s))
              (or admin-specials? (zero? (or (:special/hide-on-page s) 0)))))
          specials)]
    [:div.product-page-price-block
     [:p.product-page-delivery.u-text-center
      (when (> (or (:minprice product) 0) delivery-threshold)
        [:span
         [:span.text-pill.text-pill--tiny.text-pill--dark.u-text-uppercase "Free delivery"]
         " on this item. "])
      [:span
       (help-link app-atom help-article-delivery-charges "See delivery options.")]]
     [:p.product-page-price
      (if (pos? (or price 0))
        [:span
         [(if has-was-price? :b.product-page-price__now :b)
          [:span {:content (long display-price)}
           (str "R" (yuc/number-format display-price 0))]]
         (when has-was-price?
           [:span
            [:span.u-hidden-from-view " | "]
            [:span.product-page-price__was
             (str "Was: R" (yuc/number-format display-pricewas 0))]])]
        [:b "TBA"])]
     [:ul.product-page-alt-price
      [:li.product-page-alt-price__item
       [:i.product-page-alt-price__icon
        {:class (yuc/bem :icon [:ebucks :small :inline])}]
       [:span
        (str "eB " (yuc/number-format alt-price 0))]]
      [:li.product-page-alt-price__item
       [:i.product-page-alt-price__icon
        {:class (yuc/bem :icon [:discovery :small :inline])}]
       [:span
        (str (yuc/number-format alt-price 0) " Miles")]]
      (when (and (cmn/curact app-atom [:features :payflex]) (pos? (or price 0)))
        [:li
         {:class (yuc/bem :product-page-alt-price__item [:bnpl])}
         [:i.product-page-alt-price__icon
          {:class (yuc/bem :icon [:payflex :small :inline])}]
         [:span (str "Buy now, pay later from 4 x " (payflex-instalment display-price))]])]
     (when-let [time-special
                (->> specials
                  (filter
                    #(and
                       (= 1 (:special/timebased %))
                       (pos? (or (:special/dateto %) 0))))
                  first)]
       (product-countdown-timer time-special))
     (when (seq specials-to-show)
       [:div.product-page-specials
        (for [special specials-to-show
              :let [hidden? (= 1 (or (:special/hide-on-page special) 0))
                    link-vids (set (map :variationid (:special/links special)))
                    variation-included?
                    (or (empty? link-vids)
                      (contains? link-vids 0)
                      (contains? link-vids (:variation/id variation)))
                    soldout?
                    (or
                      (get-in special [:special/soldout (:id product)])
                      (:special/giftsoldout special))]]
          [:div.product-page-special {:key (:special/id special)}
           (when-not hidden?
             [:p
              {:class
               (str "product-page-special__text yc-paragraph yc-paragraph--medium-large yc-paragraph--flush u-block-center u-max-width-280 text-status u-text-line-height-normal u-text-center"
                 (when (and variation-included? (not soldout?)) " text-status--sale"))}
              [:b.product-page-special__title
               (cond
                 (not variation-included?)
                 (if (:variation/feature2 variation)
                   "Special on other colours"
                   "Special on other variants")

                 soldout?
                 "Special sold out"

                 :else
                 {:dangerouslySetInnerHTML {:__html (:special/comments special)}})]
              [:span.u-block.u-text-center.u-text-line-height-1
               [:a.text-link.text-link--muted.u-text-14
                {:href "#"
                 :on-click
                 (fn [e]
                   (.preventDefault e)
                   (open-special-modal app-atom special))}
                "Learn more."]]
              (when-let [img-src (special-image-url special)]
                [:img
                 {:src img-src :alt "" :width "1" :height "1"
                  :style {:position "absolute" :opacity 0 :pointer-events "none"}}])])
           (when admin-specials?
             [:div.u-block-center.u-max-width-240.u-margin-top-8.u-text-center
              (buttons/button-web
                (if hidden? "Edit Hidden Special" "Edit Special")
                {:style :light
                 :size :small
                 :full true
                 :href (str "/admin/specials.htm?action=edit&id=" (:special/id special))
                 :target "_blank"})])])])]))

(def ^:private canonical-query-params #{"id" "name" "vid"})

(defn- carried-query
  "The query string minus the params the canonical URL rebuilds. Click ids and
   utms have to survive the rewrite byte-exact, so pairs pass through raw."
  [search]
  (->>
    (str/split (str/replace search #"^[?]" "") #"&")
    (remove str/blank?)
    (remove
      (fn [pair]
        (contains? canonical-query-params
          (str/lower (first (str/split pair #"=" 2))))))
    (str/join "&")))

(defn- product-url
  "Canonical id/name/vid for the variation, plus the rest of the current query.
   Every URL rewrite on this page goes through here."
  [base product variation-id]
  #?(:cljs
     (let [carried (yuc/presence (carried-query (.-search js/window.location)))]
       (str base
         (vlist/variation-query-string product variation-id)
         (when carried (str "&" carried))))
     :clj (str base (vlist/variation-query-string product variation-id))))

(defn- variation-url
  "Build a product variation URL: /<product-url>.htm?id=<id>&name=<slug>&vid=<variation-id>"
  [product varoption]
  (let [base-path
        (or
          (:page-url product)
          (when (yuc/presence (:url product))
            (str "/" (:url product) ".htm"))
          #?(:cljs (.-pathname js/window.location)
             :clj ".htm"))]
    (str base-path (vlist/variation-query-string product (:variation/id varoption)))))

(defn- dotdigital-variant
  "One productBrowse `variants` entry, mirroring the catalog sync's
   `variant-record`. Values are the catalog's own (`attach-dotdigital-catalog`):
   `price` is the was-price when on special, with the selling price as
   `salePrice`. `stock` is the catalog's sellable flag as 1/0, not the count,
   which would publish inventory levels in the page."
  [product variation]
  #?(:cljs
     (let [{:variation/keys
            [image dotdigital-name dotdigital-price dotdigital-sale-price dotdigital-in-stock]}
           variation]
       (cond->
         {:id (str (:variation/uuid variation))
          :sku (:variation/name variation)
          :name dotdigital-name
          :url (str (.-origin js/window.location) (variation-url product variation))
          :imageUrl (:doc/url image)
          :imageThumbnailUrl (:doc/url image)
          :price dotdigital-price
          :currency "ZAR"
          :stock (if dotdigital-in-stock 1 0)}
         dotdigital-sale-price (assoc :salePrice dotdigital-sale-price)))
     :clj nil))

(defn- dotdigital-product
  "Dotdigital Tag productBrowse payload. `id` / `variantId` are the content /
   variation uuids the Dotdigital catalog sync keys its records and variants
   on, which is what links the browse to the catalog product; `variants`
   carries every variation so `variantId` resolves to one. SKU, prices and
   URL are the catalog record's product-level ones — its
   `:dotdigital-variation-id` variation's, not the one being viewed — since
   Dotdigital treats a mismatch as a different product."
  [product variation]
  #?(:cljs
     (let [viewed (dotdigital-variant product variation)

           catalog-variant
           (dotdigital-variant product
             (or (get-in product [:variations (:dotdigital-variation-id product)]) variation))]
       (merge
         (select-keys catalog-variant [:sku :url :price :salePrice :currency])
         (select-keys viewed [:imageUrl :imageThumbnailUrl])
         {:id (str (:uuid product))
          :variantId (:id viewed)
          :name (:name product)
          :brand (:product/brand-root-name product)
          :variants (mapv #(dotdigital-variant product %) (vals (:variations product)))}))
     :clj nil))

(defn- fire-product-impression!
  "Push productDetailImpression once per distinct product view. The mount
   path and the details-receive path can both attempt the same view (hard
   load vs back/forward), so an in-memory guard on the last-pushed
   [product-id variation-id] dedups them; it resets per document load —
   a fresh page view is a fresh impression. A switch back to an earlier
   variation is a new view and fires again."
  [product variation datalayer]
  #?(:cljs
     (when (and datalayer (exists? js/dataLayer))
       (let [k [(:id product) (:variation/id variation)]]
         (when (not= k @last-impression-atom)
           (reset! last-impression-atom k)
           ;; Rides inside :ecommerce so the clearing push also clears it —
           ;; a stale :salePrice must not carry over to the next product
           (tracking/push-ecommerce-event!
             (cond-> datalayer
               (:uuid product)
               (assoc-in [:ecommerce :dotdigital] (dotdigital-product product variation)))))))))

(defn variation-display-name
  "PHP feedFormatProductName parity: \"name, feature2, feature1\". Also used
   by the Clojure page shell (ycweb.app.website.page) for the server-rendered
   <title>, so it matches what set-page-title! sets after hydration."
  [product {:variation/keys [feature1 feature2]}]
  (->>
    [(:name product) feature2 feature1]
    (map #(some-> % str/trim))
    (remove str/blank?)
    (str/join ", ")))

(defn- set-page-title!
  "Sync the document title and og:title meta tag to the selected variation."
  [product variation]
  (let [vname (variation-display-name product variation)]
    (when (yuc/presence vname)
      (web-common/set-meta-title! (str vname " - Yuppiechef") vname))))

(defn switch-variation
  "Switch to a different variation instantly from pre-loaded data.
   Updates the URL via pushState, syncs the page title, swaps the
   variation client-side, and fires an async stock refresh."
  [process-atom product variation-id]
  #?(:cljs
     (let [base
           (or
             (:page-url product)
             (when (yuc/presence (:url product))
               (str "/" (:url product) ".htm"))
             (.-pathname js/window.location))]
       (.pushState js/history nil nil
         (product-url base product variation-id)))
     :clj nil)
  (let [new-variation (get-in product [:variations variation-id])]
    (when new-variation
      (let [current-variation (cmn/curact process-atom :variation)]
        (swap! process-atom assoc
          :variation (assoc new-variation
                       :variation/show-highres (:variation/show-highres current-variation)
                       :variation/user-hash (:variation/user-hash current-variation))
          :open-panel nil
          :variation-list-open? false)
        #?(:cljs (.remove (.-classList (.-body js/document)) "body--no-scroll")
           :clj nil))
      (set-page-title! product new-variation)
      (comms/ajax-get :web.product/variation-stock
        {:product-id (:id product) :variation-id variation-id}))))

(defmethod comms/receive :web.product/variation-stock [app-atom e]
  (let [process-atom (cmn/process-cursor app-atom)
        {:keys [product variation]} @process-atom
        current-variation-id (:variation/id variation)]
    (when (= current-variation-id (:variation-id e))
      (swap! process-atom update :variation assoc :variation/stockmessage (:stockmessage e))
      ;; PHP fired an impression per variation URL load; the SPA switches
      ;; variations client-side, so the per-view push rides this refresh
      (fire-product-impression! product variation (:datalayer e)))))

(rum/defc variation-product-code < rum/static [variation]
  (when-let [code (yuc/presence (:variation/name variation))]
    [:p.yc-paragraph.yc-paragraph--small.yc-paragraph--flush
     [:b "Product Code: "] code]))

(rum/defc variation-selector-nav < rum/static [process-atom product variation]
  (let [variations
        (if-let [order (:product/variation-order product)]
          (keep #(get (:variations product) %) order)
          (vals (:variations product)))
        variation-count (count variations)
        {:variation/keys [feature1 feature2 feature3]} variation
        has-f2? (not (str/blank? feature2))
        has-f1-or-f3?
        (or
          (not (str/blank? feature1))
          (not (str/blank? feature3)))
        colour-mode? has-f2?
        limit-class (when (> variation-count 8) " var-nav-wrapper--limit")
        selected-name
        (cond
          has-f2? feature2
          :else (str/trim (str (or feature1 "") " " (or feature3 ""))))]
    (when (and (> variation-count 1) (or has-f2? has-f1-or-f3?))
      [:div
       [:p.yc-paragraph.yc-paragraph--small
        [:b (if colour-mode? "Selected colour: " "Selected variant: ")]
        selected-name]
       [:nav
        {:class
         (str "var-nav-wrapper swipe-scroll-wrapper swipe-scroll-wrapper--has-fade js-swipe-scroll-wrapper"
           (when-not colour-mode? " u-margin-top-24")
           limit-class)}
        [:ul.var-nav.swipe-scroll.js-drag-scroll
         [:li.var-nav__item.var-nav__button-wrapper
          [:a.var-nav-button.js-open-choose-variant-modal
           {:href "#"
            :on-click
            (fn [e]
              (.preventDefault e)
              (vlist/open-variation-list process-atom))}
           [:span.var-nav-button__text
            (str "See all " variation-count (if colour-mode? " colours" " options"))
            [:i.icon.icon--arrow-right.icon--is-dark.icon--default.icon--block.var-nav-button__icon]]]]
         (for [varoption variations]
           (let [is-active? (= (:variation/id varoption) (:variation/id variation))
                 is-sold? (not-sellable? varoption)
                 link-class
                 (str "var-nav__link"
                   (when colour-mode? " var-nav__link--colour")
                   (when is-active? " var-nav__link--is-active")
                   (when is-sold? " var-nav__link--is-sold"))]
             [:li.var-nav__item.swipe-scroll__item {:key (:variation/id varoption)}
              [:a {:href (variation-url product varoption)
                   :class link-class
                   :on-click
                   (fn [e]
                     (.preventDefault e)
                     (switch-variation process-atom product (:variation/id varoption)))}
               (if colour-mode?
                 [:span.var-nav__content
                  [:span.var-nav__colour
                   (when-let [hex (:variation/colour-hex varoption)]
                     {:style {:background-color hex}})
                   [:span.var-nav__colour-status]]
                  [:span.var-nav__text (:variation/feature2 varoption)]]
                 [:span.var-nav__content
                  [:span.var-nav__item-text
                   (or (:variation/feature1 varoption) (:variation/feature3 varoption))]])]]))]]])))

(rum/defc variation-stock-status < rum/static [app-atom product variation]
  (let [{:variation/keys [stockmessage]} variation
        {:stock/keys [availability availability2 availability-class
                      show-notify]} stockmessage
        not-sell? (not-sellable? variation)
        avail-class (or availability-class "info")
        show-how-long?
        (and
          (not not-sell?)
          (contains? #{"in-stock" "available-stock"} avail-class))]
    [:div.feedback.feedback--small.feedback--flush
     {:class (str "feedback--" avail-class)}
     [:div.feedback__icon
      [:i.icon.icon--inline {:class (str "icon--" avail-class)}]]
     [:div.feedback__message
      [:div.feedback-title
       ;; Server-built strings can include <br> (e.g. "Available in selected stores.<br>Awaiting online stock") — render as HTML.
       [:span {:dangerouslySetInnerHTML
               {:__html (or availability "This item is not available.")}}]
       (when (and not-sell? (= show-notify "Yes"))
         [:a.text-link.js-notify-link
          {:href "#"
           :on-click
           (fn [e]
             (.preventDefault e)
             (notify-me/open-notify-me-modal app-atom product variation))}
          " Notify me."])]
      (when (or availability2 show-how-long?)
        [:div.feedback-description
         (when availability2
           [:span {:dangerouslySetInnerHTML {:__html availability2}}])
         (when show-how-long?
           [:span.u-block
            (help-link app-atom help-article-delivery-times "How long will it take to arrive?")])])]]))

(rum/defc action-price-pill < rum/static [variation]
  (let [{:variation/keys [feature1 feature2 feature3 price variation-special]} variation
        has-features?
        (or (not (str/blank? feature1))
          (not (str/blank? feature2))
          (not (str/blank? feature3)))
        selected-name
        (cond
          (not (str/blank? feature2)) feature2
          :else (str/trim (str (or feature1 "") " " (or feature3 ""))))
        has-sale? (and variation-special (:special/short-desc variation-special))
        pill-class
        (str "product-action-nav__price text-pill text-pill--default text-pill--light"
          (when has-sale? " text-pill--sale u-text-white"))]
    [:span {:class pill-class :aria-hidden "true"}
     (when has-features?
       [:span
        [:span selected-name]
        [:span.u-pipe " - "]])
     [:span (str "R" (yuc/number-format (or price 0) 0))]]))

(rum/defc context-menu-body < rum/reactive [app-atom config-atom m-config]
  (let [{:keys [show-registry? show-wishlist? content-id variation-id]}
        (cmn/curact config-atom [:config])]
    [:ul.context-menu-list
     (when show-registry?
       [:li.context-menu-list__item
        (buttons/button-web "Add to registry"
          {:type :button
           :style :secondary
           :size :large
           :full true
           :class "button--bordered"
           :icon :gift
           :icon-placement :left
           :on-click
           (fn [e]
             (.preventDefault e)
             (grid/close-modal app-atom)
             (add-to-registry app-atom variation-id))})])
     (when show-wishlist?
       [:li.context-menu-list__item
        (buttons/button-web "Add to wish list"
          {:type :button
           :style :secondary
           :size :large
           :full true
           :class "button--bordered"
           :icon :heart
           :icon-placement :left
           :on-click
           (fn [e]
             (.preventDefault e)
             (grid/close-modal app-atom)
             (add-to-wishlist app-atom variation-id))})])
     [:li.context-menu-list__item
      (buttons/button-web "Cancel"
        {:type :button
         :style :primary
         :size :large
         :full true
         :flat-style :flat
         :icon :close
         :icon-placement :left
         :class "button--reversed button--bordered button--translucent u-text-white"
         :on-click #(grid/close-modal app-atom)})]]))

(defmethod grid/modal-config :web.product/context-menu [_ _ _]
  {:body context-menu-body
   :modal-type :context-menu})

(defn open-context-menu
  [app-atom {:keys [show-registry? show-wishlist? content-id variation-id]}]
  (grid/open-modal app-atom :web.product/context-menu
    {:config {:show-registry? show-registry?
              :show-wishlist? show-wishlist?
              :content-id content-id
              :variation-id variation-id}}))

(defn open-image-zoom [process-atom images start-index]
  (swap! process-atom assoc :image-zoom
    {:open? true :current-index start-index :images images})
  #?(:cljs (.add (.-classList (.-body js/document)) "body--no-scroll")
     :clj nil))

(defn close-image-zoom [process-atom]
  (swap! process-atom dissoc :image-zoom)
  #?(:cljs (.remove (.-classList (.-body js/document)) "body--no-scroll")
     :clj nil))

(rum/defc image-zoom-popup <
  {:did-mount
   (fn [state]
     #?(:cljs
        (let [[_ _ zoom-src _] (:rum/args state)
              dom-node (rum/dom-node state)
              zoom-content (.querySelector dom-node ".yc-popup__zoom-content")]
          (when (and zoom-content zoom-src)
            (.zoom (js/$ zoom-content)
              #js {:url zoom-src :on "click"
                   :callback
                   (fn []
                     (when-let [tip (.querySelector dom-node ".yc-popup__zoom-tip")]
                       (set! (.. tip -style -display) "block")))}))))
     state)
   :will-unmount
   (fn [state]
     #?(:cljs
        (let [dom-node (rum/dom-node state)]
          (when-let [zoom-content (.querySelector dom-node ".yc-popup__zoom-content")]
            (.trigger (js/$ zoom-content) "zoom.destroy"))))
     state)}
  [process-atom display-src zoom-src alt-text]
  [:div.yc-popup.yc-popup--zoom
   {:on-click (fn [e] (.stopPropagation e))}
   [:div.yc-popup__close-button-wrapper
    {:style {:z-index 1}}
    [:button.yc-popup__close-button
     {:type "button"
      :style {:border "none" :background "none" :cursor "pointer"}
      :on-click #(close-image-zoom process-atom)}
     [:i.icon.icon--block.icon--default.icon--is-dark.icon--close]
     [:span.u-hidden-from-view "Close"]]]
   [:div.yc-popup__zoom-content
    [:img.yc-simple-image.yc-simple-image--full.yc-simple-image--center.js-zoom-img
     {:src display-src
      :alt alt-text}]]
   [:div.yc-popup__zoom-tip
    {:style {:display "none"}}
    [:span.text-pill.text-pill--medium.text-pill--light
     "Click on image to zoom"]]])

(rum/defc image-zoom-modal < rum/reactive [process-atom content-name]
  (let [{:keys [open? current-index images]}
        (cmn/curact process-atom [:image-zoom])]
    (when open?
      (let [current-image (nth images current-index nil)
            display-src (when current-image (gallery/get-display-src current-image))
            zoom-src (when current-image (gallery/get-zoom-src current-image))
            alt-text (when current-image (gallery/get-alt-text current-image (or content-name "")))]
        [:div.image-zoom-wrapper
         [:div.modal-overlay.modal-overlay--is-open
          {:on-click #(close-image-zoom process-atom)}]
         [:div
          {:style
           {:position "fixed" :top 0 :left 0 :right 0 :bottom 0
            :z-index 1043 :display "flex" :align-items "center"
            :justify-content "center" :padding "16px" :box-sizing "border-box"}
           :on-click #(close-image-zoom process-atom)}
          ;; Key on zoom-src so the popup remounts per image — the jQuery
          ;; zoom plugin holds overlay state in :did-mount and won't pick up
          ;; a new src on prop update alone.
          (rum/with-key
            (image-zoom-popup process-atom display-src zoom-src alt-text)
            (str "zoom-" zoom-src))]]))))

(rum/defc variation-action-nav-not-sellable < rum/static [app-atom product variation]
  (let [{:variation/keys [id stockmessage]} variation
        {:stock/keys [show-notify show-registry show-wishlist]} stockmessage
        show-notify? (= show-notify "Yes")
        show-registry? (= show-registry "Yes")
        show-wishlist? (= show-wishlist "Yes")
        content-id (:id product)]
    [:div.product-add-to-cart-form
     [:div.product-action-nav
      [:div.product-action-nav__item.product-action-nav__item--primary
       {:data-product-action-type "find"}
       [:button
        {:class (yuc/bem :product-action-button [:find] :button [:secondary :full])
         :type "button"
         :on-click
         (if (trf/toboolean (:product/is-dropship product))
           #(grid/open-modal app-atom :web.keepaside/modal-dropship)
           #(grid/dispatch-action app-atom :web.keepaside/start {}))}
        [:span.product-action-button__text.button__text
         [:i.product-action-button__icon
          {:class (yuc/bem :icon [:location :is-dark :default :block])}]
         [:span.product-action-button__label
          (if (trf/toboolean (:product/is-dropship product)) "Online exclusive" "Find in store")]]
        [:span.product-action-button__float-label
         {:aria-hidden "true"} "Stores"]]]
      (when show-notify?
        [:div.product-action-nav__item.product-action-nav__item--secondary
         {:data-product-action-type "notify"}
         [:a.product-action-button.product-action-button--find.button.button--full.button--secondary
          {:href "#"
           :on-click
           (fn [e]
             (.preventDefault e)
             (notify-me/open-notify-me-modal app-atom product variation))}
          [:span.product-action-button__text.button__text
           [:i.product-action-button__icon.icon.icon--block.icon--default.icon--is-dark.icon--alert]
           [:span.product-action-button__label "Notify me"]]
          [:span.product-action-button__float-label {:aria-hidden "true"} "Notify me"]]])
      (when show-registry?
        [:div.product-action-nav__item.product-action-nav__item--secondary
         {:data-product-action-type "registry"}
         [:button.product-action-button.product-action-button--plus.button.button--full.button--secondary
          {:type "button"
           :on-click (fn [e] (.preventDefault e) (add-to-registry app-atom id))}
          [:span.product-action-button__text.button__text
           [:i.product-action-button__icon.icon.icon--block.icon--default.icon--is-dark.icon--ring]
           [:span.product-action-button__label "Add to registry"]]
          [:span.product-action-button__float-label {:aria-hidden "true"} "Registry"]]])
      (when show-wishlist?
        [:div.product-action-nav__item.product-action-nav__item--secondary
         {:data-product-action-type "wishlist"}
         [:button.product-action-button.product-action-button--plus.button.button--full.button--secondary
          {:type "button"
           :on-click (fn [e] (.preventDefault e) (add-to-wishlist app-atom id))}
          [:span.product-action-button__text.button__text
           [:i.product-action-button__icon.icon.icon--block.icon--default.icon--is-dark.icon--heart]
           [:span.product-action-button__label "Add to wish list"]]
          [:span.product-action-button__float-label {:aria-hidden "true"} "Wish list"]]])
      (when (or show-registry? show-wishlist?)
        [:div.product-action-nav__item.product-action-nav__item--secondary
         {:data-product-action-type "more"}
         [:button.product-action-button.button.button--full.button--secondary
          {:type "button"
           :on-click
           #(open-context-menu app-atom
              {:show-registry? show-registry?
               :show-wishlist? show-wishlist?
               :content-id content-id
               :variation-id id})}
          [:span.product-action-button__text.button__text
           [:i.product-action-button__icon.icon.icon--block.icon--default.icon--is-dark.icon--dots-menu-horizontal]
           [:span.product-action-button__label "More"]]
          [:span.product-action-button__float-label {:aria-hidden "true"} "More"]]])
      (action-price-pill variation)]]))

(rum/defcs variation-action-nav-is-sellable < rum/reactive
  (rum/local 1 ::selected-qty)
  [state app-atom product variation]
  (let [{variation-uuid :variation/uuid
         :variation/keys [id price maxdropdown selling-pack-size stockmessage
                          geofenced-snippet]} variation
        {:stock/keys [show-registry show-wishlist]} stockmessage
        show-registry? (= show-registry "Yes")
        show-wishlist? (= show-wishlist "Yes")
        has-pack-size? (and selling-pack-size (> selling-pack-size 1))
        max-qty (or maxdropdown 20)
        content-id (:id product)
        selected-qty-atom (::selected-qty state)
        process-atom (cmn/process-cursor app-atom)
        adding-to-cart? (cmn/curact process-atom :adding-to-cart)
        new-cart-enabled (cmn/curact app-atom [:features :new-cart])]
    [:div.product-add-to-cart-form
     [:div.product-qty-selector
      [:label.product-qty-selector__label {:for (str "qty" id)}
       "Q" [:span.clip-text.clip-text--ml.unclip-text--l "uanti"] "ty:"]
      [:div.product-qty-selector__input
       [:select.select
        {:id (str "qty" id)
         :value (str @selected-qty-atom)
         :on-change
         (fn [e]
           (reset! selected-qty-atom
             #?(:cljs (js/parseInt (.. e -target -value) 10)
                :clj 1)))}
        (for [i (range 1 (inc max-qty))]
          (let [qty-val (if has-pack-size? (* i selling-pack-size) i)]
            [:option {:value (str qty-val) :key i}
             (str qty-val)]))]]
      [:span.product-qty-selector__text
       (str "x R" (yuc/number-format (or price 0) 0))]]
     [:div.product-action-nav
      [:div.product-action-nav__item.product-action-nav__item--primary
       {:data-product-action-type "cart"}
       (if new-cart-enabled
         (buttons/button-web "Add to Cart"
           {:type :button
            :style :primary
            :size :large
            :full true
            :icon :cart
            :class "add-to-cart-button"
            :icon-placement :left
            :id "addToCartButton"
            :loading? adding-to-cart?
            :loading-text "Loading..."
            :on-click
            (fn [_]
              (grid/dispatch-action app-atom :web.product/add-to-cart
                {:variation-uuid variation-uuid
                 :qty @selected-qty-atom
                 :geofenced-snippet geofenced-snippet})
              (reset! selected-qty-atom 1))})
         [:form.addToCart.js-addtocartform
          {:action "/cart.htm?action=addtocart" :method "post"}
          [:input {:type "hidden" :id "whichButtonClicked" :name "whichButtonClicked"}]
          [:input {:type "hidden" :name "addsource" :value "productdetail"}]
          [:input {:type "hidden" :name "contentid" :value (str content-id)}]
          [:input
           {:type "hidden" :name (str "qty[" id "]") :value (str @selected-qty-atom)
            :data-variationid (str id) :class "addToCartQty js-addToCartQty"}]
          [:button#addToCartButton.add-to-cart-button.button.button--raised.button--default.button--full.button--primary.button--has-icon-left
           {:type "submit"
            :name "addToCartButton"
            :class
            (if (yuc/presence geofenced-snippet)
              "js-add-to-cart-with-geofence"
              "js-add-to-cart")
            :data-load-with-icon
            "icon  icon--inline  icon--in-copy-left  icon--loading  icon--is-light  u-animate-spin"
            :style {:font-size "1.125rem"}}
           [:span.button__text
            [:i.icon.icon--cart.icon--is-light.icon--default.icon--inline.button__icon]
            "Add to Cart"]]])]
      [:div.product-action-nav__item.product-action-nav__item--secondary
       {:data-product-action-type "find"}
       [:button
        {:class (yuc/bem :product-action-button [:find] :button [:secondary :full])
         :type "button"
         :on-click
         (if (trf/toboolean (:product/is-dropship product))
           #(grid/open-modal app-atom :web.keepaside/modal-dropship)
           #(grid/dispatch-action app-atom :web.keepaside/start {}))}
        [:span.product-action-button__text.button__text
         [:i.product-action-button__icon
          {:class (yuc/bem :icon [:location :is-dark :default :block])}]
         [:span.product-action-button__label
          (if (trf/toboolean (:product/is-dropship product)) "Online exclusive" "Find in store")]]
        [:span.product-action-button__float-label
         {:aria-hidden "true"} "Stores"]]]
      (when show-registry?
        [:div.product-action-nav__item.product-action-nav__item--secondary
         {:data-product-action-type "registry"}
         [:button.product-action-button.product-action-button--plus.button.button--full.button--secondary
          {:type "button"
           :on-click (fn [e] (.preventDefault e) (add-to-registry app-atom id))}
          [:span.product-action-button__text.button__text
           [:i.product-action-button__icon.icon.icon--block.icon--default.icon--is-dark.icon--ring]
           [:span.product-action-button__label "Add to registry"]]
          [:span.product-action-button__float-label {:aria-hidden "true"} "Registry"]]])
      (when show-wishlist?
        [:div.product-action-nav__item.product-action-nav__item--secondary
         {:data-product-action-type "wishlist"}
         [:button.product-action-button.product-action-button--plus.button.button--full.button--secondary
          {:type "button"
           :on-click (fn [e] (.preventDefault e) (add-to-wishlist app-atom id))}
          [:span.product-action-button__text.button__text
           [:i.product-action-button__icon.icon.icon--block.icon--default.icon--is-dark.icon--heart]
           [:span.product-action-button__label "Add to wish list"]]
          [:span.product-action-button__float-label {:aria-hidden "true"} "Wish list"]]])
      (when (or show-registry? show-wishlist?)
        [:div.product-action-nav__item.product-action-nav__item--secondary
         {:data-product-action-type "more"}
         [:button.product-action-button.button.button--full.button--secondary
          {:type "button"
           :on-click
           #(open-context-menu app-atom
              {:show-registry? show-registry?
               :show-wishlist? show-wishlist?
               :content-id content-id
               :variation-id id})}
          [:span.product-action-button__text.button__text
           [:i.product-action-button__icon.icon.icon--block.icon--default.icon--is-dark.icon--dots-menu-horizontal]
           [:span.product-action-button__label "More"]]
          [:span.product-action-button__float-label {:aria-hidden "true"} "More"]]])
      (action-price-pill variation)]]))

(rum/defc variation-qr-code < rum/static [product variation]
  (let [{:variation/keys [id feature1 feature2 feature3]} variation]
    (when id
      (let [content-name (:product/content-name product)
            variant-desc
            (cond
              (not (str/blank? feature2))
              (str " - " feature2)

              (or (not (str/blank? feature1))
                (not (str/blank? feature3)))
              (str " - " (build-feature-string feature1 feature3))

              :else "")
            alt-text (str "QR Code for the " content-name variant-desc)]
        [:div.product-page-qr-code
         [:div.product-page-qr-code__hero
          [:img.yc-simple-image.yc-simple-image--full
           {:src (str "/api/qr/variation/" id ".png?size=182&margin=0&lookup=WEB")
            :alt alt-text}]]
         [:div.product-page-qr-code__text
          [:p.yc-paragraph.yc-paragraph--flush
           "Scan the QR code to open this page on your mobile"
           [:span.clip-text--m.unclip-text--l " phone"] "."]]]))))

(defn- jump-nav-items [product]
  (let [{:product/keys [reviewable]
         :keys [teaser summary content specs care warranty
                download videos review-stats]} product]
    (cond-> []
      (or (yuc/presence teaser) (yuc/presence summary) (yuc/presence content))
      (conj {:key :info :label "Product info" :panel :info})

      (seq videos)
      (conj {:key :videos :label "Videos" :panel :videos})

      (yuc/presence specs)
      (conj {:key :specs :label "Specifications" :panel :specs})

      true
      (conj {:key :features :label "Features" :panel :features})

      (yuc/presence care)
      (conj {:key :care :label "Care instructions" :panel :care})

      (yuc/presence warranty)
      (conj {:key :warranty :label "Warranty" :panel :warranty})

      (seq download)
      (conj {:key :downloads :label "Downloads" :panel :downloads})

      true
      (conj {:key :shipping :label "Shipping & returns" :panel :shipping :mobile-only? true})

      true
      (conj {:key :categories :label "Similar categories" :panel :categories :mobile-only? true})

      (and reviewable (> (or (:review-stats/total-reviews review-stats) 0) 0))
      (conj {:key :reviews :label "Reviews" :scroll-to "reviews"}))))

(rum/defc variation-jump-nav < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        product (cmn/curact process-atom :product)
        items (jump-nav-items product)]
    [:nav.jump-nav-wrapper
     [:ul.jump-nav
      (for [{:keys [label panel scroll-to mobile-only?] nav-key :key} items]
        [:li {:key (name nav-key)
              :class
              (cond-> "jump-nav__item"
                mobile-only? (str " jump-nav__item--is-mobile-only"))}
         [:a.jump-nav__link
          (cond
            scroll-to
            {:href (str "#" scroll-to)
             :on-click (fn [e] (scroll/scroll-to-id e scroll-to))}

            panel
            {:href "#"
             :on-click
             (fn [e]
               (.preventDefault e)
               (panels/open-panel process-atom panel))})
          [:span.jump-nav__text label]
          [:span.jump-nav__icon-wrapper
           [:i.icon.icon--block.icon--default.icon--is-dark.icon--arrow-right]]]])]]))

(def ^:private slick-04-up-config
  ;; Matches shared-general.js:203-235 (`.js-slick-carousel-04-up`).
  #?(:cljs
     (js-obj
       "lazyLoad" "ondemand"
       "dots" true
       "arrows" false
       "infinite" false
       "slidesToShow" 2
       "slidesToScroll" 2
       "prevArrow" "<button type='button' aria-label='Previous' class='slick-prev'><span class='u-hidden-from-view'>Previous</span><i class='icon  icon--block  icon--chevron-left'></i></button>"
       "nextArrow" "<button type='button' aria-label='Next' class='slick-next'><span class='u-hidden-from-view'>Next</span><i class='icon  icon--block  icon--chevron-right'></i></button>"
       ;; rows:0 workaround for slick v1.8.0 — https://github.com/kenwheeler/slick/issues/3207
       "rows" 0
       "mobileFirst" true
       "responsive" (array
                      (js-obj "breakpoint" 760
                        "settings" (js-obj "slidesToShow" 3 "slidesToScroll" 3 "dots" false "arrows" true))
                      (js-obj "breakpoint" 1000
                        "settings" (js-obj "slidesToShow" 4 "slidesToScroll" 4 "dots" false "arrows" true))))
     :clj nil))

(defn- slick-04-up-mount! [state]
  #?(:cljs
     (let [$el (.find (js/$ (rum/dom-node state)) ".js-slick-carousel-04-up")]
       (when (and (pos? (.-length $el))
               (not (.hasClass $el "slick-initialized")))
         (-> $el
           (.removeClass "yc-slick-carousel--not-initialised")
           (.slick slick-04-up-config)))))
  state)

(defn- slick-04-up-unmount! [state]
  #?(:cljs
     (let [$el (.find (js/$ (rum/dom-node state)) ".js-slick-carousel-04-up")]
       (when (and (pos? (.-length $el)) (.hasClass $el "slick-initialized"))
         (.slick $el "unslick"))))
  state)

(def ^:private slick-04-up-mixin
  {:did-mount slick-04-up-mount!
   :will-unmount slick-04-up-unmount!})

(defn- product-carousel-04-up [heading cards]
  [:aside.yc-section.yc-section--medium
   [:h2.yc-heading.yc-heading--default heading]
   [:div.yc-slick-carousel-wrapper
    [:div.yc-slick-carousel.yc-slick-carousel--04-up.yc-slick-carousel--not-initialised.yc-slick-carousel--has-arrows.js-slick-carousel-04-up
     cards]]])

(rum/defc product-accessories < rum/reactive slick-04-up-mixin [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        product (cmn/curact process-atom :product)
        related-products (:product/related-products product)]
    (when (seq related-products)
      (product-carousel-04-up
        "You might need these to go with it…"
        (for [p related-products]
          [:div.yc-slick-carousel__item {:key (:product/id p)}
           [:div.flex-grid-block
            (cards/product-card-default app-atom p {})]])))))

(rum/defc product-considerations < rum/reactive slick-04-up-mixin [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        product (cmn/curact process-atom :product)
        consider-products (:product/consider-products product)]
    (when (seq consider-products)
      (product-carousel-04-up
        "You might also consider\u2026"
        (for [p consider-products]
          [:div.yc-slick-carousel__item {:key (:product/id p)}
           [:div.flex-grid-block
            (cards/product-card-default app-atom p {})]])))))

(defn- write-review-link [app-atom _product variation]
  (let [user (cmn/curact app-atom [:user])
        logged-in? (some? user)
        review-url (str "/myaccount.htm?action=reviewsadd&uuid=" (:variation/uuid variation))]
    (buttons/button-web "Write a Review"
      (merge
        {:style :primary
         :full true
         :icon :pencil
         :icon-placement :left}
        (if logged-in?
          (urlstate/href-props app-atom "myaccount" "reviewsadd"
            {:uuid (:variation/uuid variation)})
          {:href (str "/login.htm?afterloginredirect=" review-url)})))))

(declare refresh-reviews!)

(rum/defc reviews-stats-breakdown < rum/static [app-atom review-stats]
  (let [{:review-stats/keys [distribution total-reviews]} review-stats
        process-atom (cmn/process-cursor app-atom)
        select-stars
        (fn [stars]
          (fn [e]
            (.preventDefault e)
            (swap! process-atom assoc-in [:review-filters :rating] (str stars))
            (refresh-reviews! app-atom)))]
    [:div.flex-grid-block.flex-grid-block--ml-1-2
     [:div.flex-grid-content
      [:ul.reviews-breakdown
       (for [stars (range 5 0 -1)]
         (let [star-data (get distribution stars)
               star-count (or (:count star-data) 0)
               percentage (:percentage star-data)
               has-reviews? (pos? star-count)
               star-el
               [:div.reviews-breakdown__star
                [:b (str stars)]
                [:div.star-rating {:class (str "star-rating--" (* stars 10))}]]
               meter-el
               [:div.reviews-breakdown__percent
                [:div.review-meter
                 [:div.review-meter__bar {:style {:width (str (or percentage "0") "%")}}
                  [:span.u-hidden-from-view (str (or percentage "0") "%")]]]]
               count-el
               [:div.reviews-breakdown__count
                (when has-reviews? "View ")
                (str star-count)
                [:span.u-hidden-from-view
                 (str " out of " total-reviews " total reviews")]]]
           (if has-reviews?
             [:li.reviews-breakdown__item {:key stars}
              [:a.reviews-breakdown__item-link
               {:href "#" :on-click (select-stars stars)}
               star-el meter-el count-el]]
             [:li.reviews-breakdown__item {:key stars}
              star-el meter-el count-el])))]]]))

(rum/defc reviews-stats-section < rum/static [app-atom review-stats product variation]
  (let [{:review-stats/keys [avg-stars total-reviews total-recommend distribution]} review-stats
        show-breakdown? (and distribution (>= total-reviews 3))]
    [:div.product-reviews__stats
     (when-not show-breakdown? {:class "product-reviews__stats--is-empty"})
     (if show-breakdown?
       [:div.flex-grid-group.flex-grid-group--flush
        [:div.flex-grid-block.flex-grid-block--ml-1-2
         [:div.flex-grid-content
          [:div.product-reviews__avg-stars
           [:div.star-rating.star-rating--large
            {:class (str "star-rating--" (int (* avg-stars 10)))}]]
          [:p.yc-paragraph.yc-paragraph--large.yc-paragraph--flush.u-text-center
           [:b (str (yuc/number-format avg-stars 1) " out of 5 stars from " total-reviews
                 (if (= total-reviews 1) " review" " reviews"))]]
          [:p.product-reviews__meta
           (str total-recommend " out of " total-reviews " people would recommend this")
           [:span.clip-text.unclip-text--m " product"]]
          [:div.u-block-center.u-margin-top-20.u-max-width-240
           (write-review-link app-atom product variation)]]]
        (reviews-stats-breakdown app-atom review-stats)]
       [:div
        [:div.product-reviews__avg-stars
         [:div.star-rating.star-rating--large
          {:class (str "star-rating--" (int (* avg-stars 10)))}]]
        [:p.yc-paragraph.yc-paragraph--large.yc-paragraph--flush.u-text-center
         [:b (str (yuc/number-format avg-stars 1) " out of 5 stars from " total-reviews
               (if (= total-reviews 1) " review" " reviews"))]]
        [:p.product-reviews__meta
         (str total-recommend " out of " total-reviews " people would recommend this")
         [:span.clip-text.unclip-text--m " product"]]
        [:div.u-block-center.u-margin-top-20.u-max-width-240
         (write-review-link app-atom product variation)]])]))

(def ^:private review-sort-options
  [["helpful" "Most Helpful"]
   ["newest"  "Newest"]
   ["oldest"  "Oldest"]])

(def ^:private review-rating-options
  [[""  "All Star Ratings"]
   ["5" "5 Star Reviews"]
   ["4" "4 Star Reviews"]
   ["3" "3 Star Reviews"]
   ["2" "2 Star Reviews"]
   ["1" "1 Star Reviews"]])

(def ^:private review-reviewer-options
  [[""         "All Reviewers"]
   ["verified" "Verified Owners"]
   ["staff"    "Staff Reviews"]])

(defn- refresh-reviews! [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        product (cmn/curact process-atom :product)
        {:keys [order rating reviewer-type]}
        (cmn/curact process-atom :review-filters)]
    (swap! process-atom assoc :reviews-loading? true)
    (comms/ajax-get :web.product/reviews-filter
      (cond-> {:product-id (:id product)
               :order (or order "helpful")}
        (yuc/presence rating)        (assoc :stars (yuc/parseInt rating))
        (yuc/presence reviewer-type) (assoc :reviewer-type reviewer-type)))))

(rum/defc review-filters < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        {:keys [order rating reviewer-type]
         :or {order "helpful" rating "" reviewer-type ""}}
        (cmn/curact process-atom :review-filters)
        on-change
        (fn [field]
          (fn [e]
            (swap! process-atom assoc-in [:review-filters field]
              (.-value (.-target e)))
            (refresh-reviews! app-atom)))]
    [:div.yc-section.yc-section--medium
     [:form.form {:on-submit #(.preventDefault %)}
      [:div.flex-grid-group.flex-grid-group--flush-force.flex-grid-group--valign-middle.flex-grid-group--align-center
       [:div.flex-grid-block.flex-grid-block--valign-middle.flex-grid-block--t-full.flex-grid-block--ml-1-3
        [:div.form.flex-grid-content
         [:div.flex-grid-group.flex-grid-group--valign-middle
          [:div.flex-grid-block.flex-grid-block--valign-middle.flex-grid-block--t-full.flex-grid-block--ml-1-4.flex-grid-block--l-2-5.review-filter-label
           [:div.flex-grid-content [:span.select__text "Sort by:"]]]
          [:div.flex-grid-block.flex-grid-block--valign-middle.flex-grid-block--t-full.flex-grid-block--ml-3-4.flex-grid-block--l-3-5
           [:div.flex-grid-content
            [:select.select
             {:name "sortby" :value order :on-change (on-change :order)}
             (for [[v label] review-sort-options]
               [:option {:value v :key (or (yuc/presence v) "all")} label])]]]]]]
       [:div.flex-grid-block.flex-grid-block--valign-middle.flex-grid-block--t-full.flex-grid-block--ml-1-3
        [:div.form.flex-grid-content
         [:div.flex-grid-group.flex-grid-group--valign-middle
          [:div.flex-grid-block.flex-grid-block--valign-middle.flex-grid-block--t-full.flex-grid-block--ml-1-4.flex-grid-block--l-2-5.review-filter-label
           [:div.flex-grid-content [:span.select__text "Filter by:"]]]
          [:div.flex-grid-block.flex-grid-block--valign-middle.flex-grid-block--t-full.flex-grid-block--ml-3-4.flex-grid-block--l-3-5
           [:div.flex-grid-content
            [:select.select
             {:name "rating" :value rating :on-change (on-change :rating)}
             (for [[v label] review-rating-options]
               [:option {:value v :key (or (yuc/presence v) "all")} label])]]]]]]
       [:div.flex-grid-block.flex-grid-block--valign-middle.flex-grid-block--t-full.flex-grid-block--ml-1-3
        [:div.form.flex-grid-content
         [:div.flex-grid-group.flex-grid-group--valign-middle
          [:div.flex-grid-block.flex-grid-block--valign-middle.flex-grid-block--t-full.flex-grid-block--ml-1-4.flex-grid-block--l-2-5.review-filter-label
           [:div.flex-grid-content [:span.select__text "Reviewed by:"]]]
          [:div.flex-grid-block.flex-grid-block--valign-middle.flex-grid-block--t-full.flex-grid-block--ml-3-4.flex-grid-block--l-3-5
           [:div.flex-grid-content
            [:select.select
             {:name "reviewer_type" :value reviewer-type :on-change (on-change :reviewer-type)}
             (for [[v label] review-reviewer-options]
               [:option {:value v :key (or (yuc/presence v) "all")} label])]]]]]]]]]))

(rum/defc product-reviews < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        {:product/keys [reviewable] :keys [review-stats] :as product} (cmn/curact process-atom :product)
        variation (cmn/curact process-atom :variation)
        reviews (cmn/curact process-atom :reviews)
        {:review-stats/keys [total-reviews]} review-stats
        initial-count 5
        show-all? (cmn/curact process-atom [:reviews-show-all?])
        loading? (cmn/curact process-atom [:reviews-loading?])]
    (when reviewable
      [:div#reviews.product-reviews.yc-section.yc-section--large
       [:h2.yc-heading.yc-heading--default.yc-heading--center
        [:span.clip-text.unclip-text--m "Customer "] "Reviews & Ratings"]
       (if (and total-reviews (pos? total-reviews))
         [:div
          (reviews-stats-section app-atom review-stats product variation)
          (when (> total-reviews 5)
            (review-filters app-atom))
          [:div.review-items-wrapper {:style {:position "relative"}}
           [:div.loading-overlay (when loading? {:class :loading-overlay--is-open})
            [:div.loading-overlay__content
             [:div.loading-overlay__icon-wrapper.u-block-center.u-max-width-48
              [:i.icon.icon--block.icon--large.icon--is-dark.icon--loading.u-animate-spin]]
             [:div.loading-overlay__text.u-margin-top-16
              [:b.loading-text.loading-text--is-absolute "Loading"]]]]
           (let [visible-reviews (if show-all? reviews (take initial-count reviews))
                 on-helpful-vote
                 (fn [review-id helpful?]
                   (comms/ajax-post :web.product/review-helpful
                     {:review-id review-id :helpful helpful?}))
                 admin-edit?
                 (cmn/curact process-atom :admin-edit-reviews?)]
             (for [r visible-reviews
                   :when (and (:review/stars r) (:ent/uuid r))
                   :let [block (reviews-common/review-block r {:on-helpful-vote on-helpful-vote
                                                               :admin-edit? admin-edit?})]]
               (assoc-in block [1 :key] (str "review-" (:ent/uuid r)))))
           [:div.product-reviews__footer
            [:div.u-block-center.u-max-width-480
             [:div.flex-grid-group.flex-grid-group--flush-force
              (when (and (not show-all?) (> (clojure.core/count reviews) initial-count))
                [:div.flex-grid-block.flex-grid-block--m-1-2.flex-grid-block--m-order-02
                 (buttons/button-web
                   (str "Load all " (clojure.core/count reviews) " reviews")
                   {:style :primary
                    :full true
                    :on-click
                    (fn [e]
                      (.preventDefault e)
                      (swap! process-atom assoc :reviews-show-all? true))})])
              [:div.flex-grid-block.flex-grid-block--m-1-2
               (when (or show-all? (<= (clojure.core/count reviews) initial-count))
                 {:class "flex-grid-block--center"})
               (write-review-link app-atom product variation)]]]]]]
         [:div.u-block-center.u-margin-top-20.u-max-width-240
          (write-review-link app-atom product variation)])])))

(rum/defc recently-viewed < rum/reactive slick-04-up-mixin [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        items (cmn/curact process-atom :recently-viewed)]
    (when (seq items)
      [:aside.yc-section.yc-section--medium
       [:h2.yc-heading.yc-heading--default.yc-heading--center "Recently viewed items"]
       [:div.yc-slick-carousel-wrapper
        [:div.yc-slick-carousel.yc-slick-carousel--04-up.yc-slick-carousel--not-initialised.yc-slick-carousel--has-arrows.js-slick-carousel-04-up
         (for [{:ent/keys [display-name image]
                :product/keys [url id]} items]
           [:div.yc-slick-carousel__item {:key id}
            [:div.flex-grid-block
             [:article.card.product-card.flex-grid-content
              [:div.card__hero
               [:a.block-link {:href url}
                (web-common/lazy-image app-atom
                  (:doc/public-id image)
                  {:class ["card__image"]}
                  {:w 233 :h 233 :c "lpad" :q "auto" :f "auto"
                   :effect "sharpen:40"
                   :border-spec (:doc/padding image)
                   :dpr 2
                   :alt display-name})]]]]])]]])))

(rum/defc product-admin-menu < rum/reactive [app-atom]
  (when (cmn/curact (cmn/process-cursor app-atom) :admin?)
    (let [process-atom (cmn/process-cursor app-atom)
          product (cmn/curact process-atom :product)
          variation (cmn/curact process-atom :variation)
          {:keys [id]} product
          {:product/keys [content-live content-live-text]} product
          cat-id (get-in (cmn/curact process-atom :categories) [:category :category/id])
          live? (and (number? content-live) (>= content-live 0))
          status-text (or content-live-text (if live? "Live" "Hidden"))
          degraded? (cmn/curact process-atom :degraded?)
          button-class
          (fn [style]
            (str "button  button--full  button--raised  button--standard  button--"
              (name style)
              (when (= style :secondary) "  button--bordered")))
          edit-url
          (fn [suffix]
            (str "/admin/products_edit.htm?overrideincludes=popup"
              "&sm[e1][action]=contentedit"
              "&sm[e1][category]=" cat-id
              "&sm[e1][cntid]=" id
              suffix))
          admin-button
          (fn [text href style]
            [:div.flex-grid-block.flex-grid-block--t-1-2.flex-grid-block--ml-1-5
             [:div.flex-grid-content
              [:a
               {:href href
                :target "_blank"
                :class (button-class style)}
               [:span.button__text text]]]])
          admin-action-button
          (fn [text on-click style]
            [:div.flex-grid-block.flex-grid-block--t-1-2.flex-grid-block--ml-1-5
             [:div.flex-grid-content
              [:button
               {:on-click on-click
                :type "button"
                :class (button-class style)}
               [:span.button__text text]]]])]
      [:div.product-admin-bar
       [:div.yc-section
        [:p.yc-paragraph.yc-paragraph--large.yc-paragraph--flush
         [:span "Product status: "]
         [:b {:class (str "text-status  text-status--" (if live? "success" "error"))}
          status-text]]
        (when degraded?
          (feedback/feedback :warning
            "Customers can't see this page"
            (str "Shoppers get a 404 and the \"not available for purchase\" message. "
              "You're seeing the product because you're a site admin.")))]
       [:div.yc-section.yc-section--standard
        [:div.flex-grid-group.flex-grid-group--align-left
         (admin-button "Edit product" (edit-url "") :primary)
         (when (cmn/curact process-atom :admin-stats?)
           (admin-button "Product stats" (edit-url "#tabs-stats") :secondary))
         (when (cmn/curact process-atom :admin-needs-work?)
           (admin-button "Needs work" (edit-url "#tabs-needs") :secondary))
         (admin-button "Supplier details" (edit-url "#tabs-supplier-details") :secondary)
         (admin-button "Troubleshooting" (edit-url "#tabs-troubleshooting") :secondary)
         (admin-action-button "Check discount"
           (fn [_]
             (comms/ajax-get :web.product/check-discount
               {:variation-id (:variation/id variation)}))
           :secondary)
         (let [base-path
               (or
                 (:page-url product)
                 (when (yuc/presence (:url product))
                   (str "/" (:url product) ".htm"))
                 #?(:cljs (.-pathname js/window.location) :clj ".htm"))]
           (admin-button "View Legacy Page"
             (str base-path "?id=" id "&vid=" (:variation/id variation) "&legacy=true")
             :secondary))]]])))

(rum/defc sale-banner < rum/static [app-atom banner]
  (let [dark-text (boolean (:text_dark banner))]
    [:div.yc-section.yc-section--standard
     [:a.u-block-link
      {:class
       (yuc/bem :card [:no-border] :text-card [:small]
         (when (:colour_name banner)
           (keyword (str "u-bg-" (:colour_name banner)))))
       :href (:url banner)
       :on-click
       (fn [e]
         (.preventDefault e)
         (grid/dispatch-action app-atom
           :web.footer/save-banner-click {:banner banner}))}
      [:p.u-text-center
       {:class
        (yuc/bem :yc-paragraph [:flush]
          (when-not dark-text :u-text-white))}
       [:i
        {:class
         (yuc/bem :icon
           [:inline :in-copy :small
            (if dark-text :is-light :is-dark)])}]
       [:b (:title banner)] " "
       [:span {:dangerouslySetInnerHTML {:__html (:description banner)}}] " "
       [:span.u-text-underline (:buttontext banner)]]]]))

(rum/defc full-product-page < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        product (cmn/curact process-atom :product)
        variation (cmn/curact process-atom :variation)
        payflex? (cmn/curact app-atom [:features :payflex])
        {:variation/keys [price selling-pack-size]} variation
        alt-price (* (or price 0) 10)
        payflex-amount
        (when (and payflex? (pos? (or price 0)))
          (* price (max 1 (or selling-pack-size 1))))
        degraded? (cmn/curact process-atom :degraded?)
        not-found? (cmn/curact process-atom :not-found?)
        banner (first (cmn/curact process-atom :banners))
        show-image-guide? (cmn/curact process-atom :show-image-guide?)
        admin? (cmn/curact process-atom :admin?)
        google-category
        (->>
          (str/split (str/replace (or (:product/cat-full-name product) "") "Categories:Pages:Products:" "") #":")
          (remove str/blank?)
          (take 5)
          (str/join "/"))]
    (cond
      not-found?
      [:main#main-content.yc-page-content.yc-page-content--standard
       [:div.yc-section
        (flow/page-not-found-content)]]

      (and degraded? (not admin?))
      [:main#main-content.yc-page-content.yc-page-content--standard
       [:div.yc-section
        (when (:product/content-name product)
          [:h2.yc-heading.yc-heading--medium.u-text-center (:product/content-name product)])
        [:p.yc-paragraph.u-text-center
         "Sorry, this product is not available for purchase at the moment."]
        [:div.u-block-center.u-max-width-240
         (buttons/button-web "Return to Homepage"
           {:href "/index.htm" :style :dark :full true})]]]

      :else
      [:div.product-page-root
       (vlist/variation-list-modal process-atom product variation
         (fn [variation-id]
           (switch-variation process-atom product variation-id)))
       (image-zoom-modal process-atom (:product/content-name product))
       (geofence-modals app-atom)
       [:main#main-content.yc-page-content.yc-page-content--standard
        [:div.product-page
         (product-admin-menu app-atom)
         (when banner
           (sale-banner app-atom banner))
         [:div.yc-section
          [:div.flex-grid-group.flex-grid-group--align-left
           [:div.flex-grid-block.flex-grid-block--full
            (page-header app-atom
              {:google-category google-category
               :productname (:product/content-name product)
               :brand (:product/brand-root-name product)})]]
          (hunt/page-hunt app-atom)
          [:div.flex-grid-group.flex-grid-group--align-left
           [:div.flex-grid-block.flex-grid-block--t-full.flex-grid-block--ml-3-5
            (gallery/content-images product variation
              {:on-zoom-click
               (fn [images idx]
                 (open-image-zoom process-atom images idx))
               :on-video-click
               (fn []
                 (panels/open-panel process-atom :videos))
               :videos (:videos product)
               :video-count (count (:videos product))
               :show-image-guide? show-image-guide?})]
           [:div.flex-grid-block.flex-grid-block--t-full.flex-grid-block--ml-2-5.flex-grid-block--l-c390px
            [:div.flex-grid-content
             [:div.product-add-to-cart-area
              (variation-price-block app-atom product variation)
              (variation-product-code variation)
              (variation-selector-nav process-atom product variation)
              (when-not degraded?
                [:div.product-stock-status
                 (variation-stock-status app-atom product variation)])
              (if (or degraded? (not-sellable? variation))
                (variation-action-nav-not-sellable app-atom product variation)
                (variation-action-nav-is-sellable app-atom product variation))
              [:p.product-secure-signal
               [:i.product-secure-signal__icon.icon.icon--block.icon--is-dark.icon--lock]
               [:b.product-secure-signal__text "Shopping on Yuppiechef is safe and secure"]]]
             (variation-qr-code product variation)]]]]

         [:div.yc-section
          (variation-teaser app-atom)
          (variation-jump-nav app-atom)
          (panels/product-info-panel process-atom)
          (panels/videos-panel process-atom)
          (panels/specs-panel process-atom)
          (panels/features-panel process-atom)
          (panels/care-panel process-atom)
          (panels/warranty-panel process-atom)
          (panels/downloads-panel process-atom)
          (panels/shipping-panel app-atom process-atom)
          (panels/categories-panel process-atom)

          [:div.product-payment-options-wrapper
           {:id "js-product-payment-options"}
           [:h2.u-hidden-from-view "Payment options"]
           [:ul.product-payment-options
            [:li.product-payment-options__item
             [:span.product-payment-options__icon-wrapper
              {:aria-hidden "true"}
              (icons/ebucks-logo)]
             [:span.u-hidden-from-view "Pay in part or full using eBucks: "]
             [:span.product-payment-options__price
              (str "eB " (yuc/number-format alt-price 0))]]
            [:li.product-payment-options__item
             [:span.product-payment-options__icon-wrapper
              {:aria-hidden "true"}
              (icons/discovery-miles-logo)]
             [:span.u-hidden-from-view
              "Pay in part or full using Discovery Miles: "]
             [:span.product-payment-options__price
              (str (yuc/number-format alt-price 0) " Miles")]]
            [:li.product-payment-options__item
             [:span.product-payment-options__icon-wrapper
              {:aria-hidden "true"}
              (icons/mobicred-logo)]
             [:span.product-payment-options__price "Pay with Mobicred Credit"]]
            (when payflex-amount
              [:li.product-payment-options__item
               [:span.product-payment-options__icon-wrapper
                {:aria-hidden "true"}
                (icons/payflex-logo)]
               [:span.u-hidden-from-view "Payflex: "]
               [:span.product-payment-options__price
                (str "Buy now, pay later. Payment plans from " (payflex-instalment payflex-amount))]])]]]

         (when (seq (:product/consider-products product))
           [:div.dlp-spacer.dlp-spacer--medium-underline])
         (product-considerations app-atom)
         (when (seq (:product/related-products product))
           [:div.dlp-spacer.dlp-spacer--medium-underline])
         (product-accessories app-atom)
         [:div.dlp-spacer.dlp-spacer--medium-underline]
         (product-reviews app-atom)
         (when (seq (cmn/curact process-atom :recently-viewed))
           [:div.dlp-spacer.dlp-spacer--medium-underline])
         (recently-viewed app-atom)]]])))

(defn- canonicalise-url! [category-page-url product variation-id]
  #?(:cljs
     (when-let [page-url (yuc/presence category-page-url)]
       (let [canonical (product-url (str "/" page-url) product variation-id)
             current
             (str (.-pathname js/window.location) (.-search js/window.location))]
         (when (not= current canonical)
           (urlstate/replace-url! canonical))))
     :clj nil))

(rum/defc product-page < rum/reactive
  {:did-mount
   (fn [state]
     (let [[app-atom] (:rum/args state)
           {:keys [categories product variation datalayer]}
           @(cmn/process-cursor app-atom)]
       (canonicalise-url!
         (get-in categories [:category :category/page-url])
         product
         (:variation/id variation))
       (fire-product-impression! product variation datalayer))
     state)}
  [app-atom]
  [:div
   (full-product-page app-atom)
   (toaster/loading-overlay app-atom :web.product/loading {:fullscreen? true})])

(defmethod flow/render-screen :web.product [app-atom _]
  (website/screen-wrapper app-atom
    (product-page app-atom)
    {}))

(defmethod t/transition-open :web.product [app-atom screen params]
  (let [page (get-in @app-atom [:page :web.product])
        cookies (get-in @app-atom [:page :cookies])
        product-id
        (or
          (:product-id params)
          (:id params)
          (yuc/parseInt (url-query-param "id")))
        variation-id
        (or
          (:variation-id params)
          (yuc/parseInt (url-query-param "vid")))]
    (when product-id
      (comms/ajax-get :web.product/details
        {:product-id product-id
         :variation-id variation-id}))))

(defmethod comms/receive :web.product/details [app-atom e]
  (let [process-atom (cmn/process-cursor app-atom)

        canonical-path
        (when-let [page-url (yuc/presence (get-in e [:category :category/page-url]))]
          (str "/" page-url))

        url-path
        (or
          canonical-path
          (:url-path (cmn/screen-params app-atom))
          #?(:cljs (.-pathname js/window.location) :clj nil))]
    (swap! process-atom assoc
      :categories (select-keys e [:category :category-paths])
      :product
      (cond-> (:product e)
        (:hunt e) (assoc :hunt (:hunt e))
        url-path (assoc :page-url url-path))
      :variation
      (assoc (:variation e)
        :variation/show-highres (:showhighres e)
        :variation/user-hash (:userhash e))
      :reviews (:reviews e)
      :recently-viewed (:recently-viewed e)
      :degraded? (:degraded? e)
      :not-found? (:not-found? e)
      :banners (:banners e)
      :delivery-threshold (:delivery-threshold e)
      :admin? (:admin? e)
      :admin-specials? (:admin-specials? e)
      :admin-stats? (:admin-stats? e)
      :admin-needs-work? (:admin-needs-work? e)
      :admin-edit-reviews? (:admin-edit-reviews? e)
      :show-image-guide? (:show-image-guide? e)
      :datalayer (:datalayer e)
      :open-panel nil
      :variation-list-open? false)
    (when (:keepaside e)
      (swap! (cmn/action-cursor app-atom) assoc
        :selected-store nil
        :keep-aside nil
        :keepaside-product (:keepaside e)
        :variation-choice {:choice "specific"}
        :selected-variations nil))
    (set-page-title! (:product e) (:variation e))
    (canonicalise-url!
      (get-in e [:category :category/page-url])
      (:product e)
      (get-in e [:variation :variation/id]))
    (let [{:keys [product variation]} @process-atom]
      (fire-product-impression! product variation (:datalayer e)))
    #?(:cljs
       (.remove (.-classList (.-body js/document)) "body--no-scroll")
       :clj nil)))

(defmethod comms/receive :web.product/reviews-filter [app-atom e]
  (let [process-atom (cmn/process-cursor app-atom)]
    (swap! process-atom assoc
      :reviews (:reviews e)
      :reviews-show-all? false
      :reviews-loading? false)))

(defmethod comms/receive :web.product/review-helpful [app-atom e]
  (when (:success e)
    (let [process-atom (cmn/process-cursor app-atom)
          {:keys [review-id helpful-count unhelpful-count total-helpful-count user-helpful?]} e]
      (swap! process-atom update :reviews
        (fn [reviews]
          (mapv
            (fn [r]
              (if (= (:review/id r) review-id)
                (assoc r
                  :review/helpful-count helpful-count
                  :review/unhelpful-count unhelpful-count
                  :review/total-helpful-count total-helpful-count
                  :review/user-helpful? user-helpful?)
                r))
            reviews))))))